import { InputContainer, Label, Input } from '../../styled-components/layout';

export const DefaultInputChat = ({ label, placeholder, loading, require, value, width, change, marginBottom, displayLabel, ref, border, onKeyDown, mobilePaddingLeft, mobilePaddingRight }) => {
    return (
        <InputContainer width={ width } marginBottom={marginBottom} mobilePaddingLeft={mobilePaddingLeft} mobilePaddingRight={mobilePaddingRight}>
            <Label displayLabel={displayLabel} ref={ref}>{ label }{ require ? "*" : "" } </Label>
            <Input onChange={change} value={value} placeholder={loading ? '' : placeholder} disabled={loading} border={border} onKeyDown={onKeyDown}/>
        </InputContainer>
    )
}